import constants from "../constants";

export default {
  saveDeviceInfo(deviceData) {
    return Promise.resolve(
      this.store(constants.STORAGE_KEY.DEVICE_DATA, JSON.stringify(this.getDeviceData()))
    );
  },
  getDeviceData() {
    return {
      deviceName: this.getDeviceOS(),
      deviceOs: navigator.platform,
      deviceOsVersion: "",
      deviceLocation: "",
      browserName: this.getBrowserFromUserAgent(navigator.userAgent),
      browserVersion: this.getBrowserVersionFromUserAgent(navigator.userAgent)
    };
  },
  removeDeviceInfo() {
    this.remove(constants.STORAGE_KEY.DEVICE_DATA);
    return Promise.resolve(null);
  },

  getDeviceInfo() {
    let deviceDataStr = this.get(constants.STORAGE_KEY.DEVICE_DATA);
    return deviceDataStr || JSON.stringify(this.getDefaultDeviceInfo());
  },


  store(key, value) {
    value == null || value === undefined ? localStorage.removeItem(key) : localStorage.setItem(key, value);
  },

  get(key) {
    return localStorage.getItem(key);
  },

  remove(key) {
    return localStorage.removeItem(key);
  },

  getDefaultDeviceInfo() {
    return {
      deviceName: "Client Not Support",
      deviceOs: "Client Not Support",
      deviceOsVersion: "Client Not Support",
      deviceLocation: "Client Not Support",
      browserName: "Client Not Support",
      browserVersion: "Client Not Support"
    };
  },
  getDeviceOS() {
    let userAgent = window.navigator.userAgent;
    let platform = window.navigator.platform;
    let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    let iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    let os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows';
    } else if (/Android/.test(userAgent)) {
      os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
      os = 'Linux';
    }

    return os;
  },

  getBrowserFromUserAgent(userAgent) {
    // console.log("userAgent",userAgent);

    if (userAgent.indexOf("Firefox") > -1) {
      return "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (userAgent.indexOf("SamsungBrowser") > -1) {
      return "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
      return "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (userAgent.indexOf("Trident") > -1) {
      return "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (userAgent.indexOf("Edg") > -1) {
      return "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    }
    else if (userAgent.indexOf("Chrome") > -1) {
        return "Google Chrome or Chromium";
        // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
      }
    else if (userAgent.indexOf("Safari") > -1) {
      return "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    }
    else {
      return "Unknown";
    }
  },

  getBrowserVersionFromUserAgent(userAgent) {

    // let browserVersion;
    let tempVersionOffset;
    //
    // if ((tempVersionOffset=userAgent.indexOf("Firefox")) > -1) {
    //   browserVersion=userAgent.substring(tempVersionOffset+8);
    //   return browserVersion;
    //   // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    // } else if ((tempVersionOffset=userAgent.indexOf("Opera")) > -1 || userAgent.indexOf("OPR") > -1) {
    //   browserVersion=userAgent.substring(tempVersionOffset+7);
    //   if ((tempVersionOffset=userAgent.indexOf("Version"))!=-1)
    //     browserVersion = userAgent.substring(tempVersionOffset+8);
    //   return browserVersion;
    //   // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    // } else if ((tempVersionOffset=userAgent.indexOf("MSIE")) > -1) {
    //   browserVersion=userAgent.substring(tempVersionOffset+5);
    //   // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    // } else if ((tempVersionOffset=userAgent.indexOf("Edg")) > -1) {
    //   browserVersion = userAgent.substring(tempVersionOffset+7);
    //   // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    // }
    // else if (userAgent.indexOf("Safari") > -1) {
    //   browserVersion = userAgent.substring(tempVersionOffset+7);
    //   if ((tempVersionOffset=userAgent.indexOf("Version"))!=-1)
    //     browserVersion = userAgent.substring(tempVersionOffset+8);
    //   // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    // }
    // else if ((tempVersionOffset=userAgent.indexOf("Chrome")) > -1) {
    //   browserVersion = userAgent.substring(tempVersionOffset+7);
    //   // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    // }  else {
    //   browserVersion= "Unknown";
    // }

    if ((tempVersionOffset=userAgent.indexOf("Firefox")) > -1) {
      return userAgent.substring(tempVersionOffset,8);
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if ((tempVersionOffset=userAgent.indexOf("Opera")) > -1) {
      return userAgent.substring(tempVersionOffset,8);
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    }
    else if ((tempVersionOffset=userAgent.indexOf("OPR")) > -1) {
      return userAgent.substring(tempVersionOffset,8);
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    }
    else if ((tempVersionOffset=userAgent.indexOf("Chrome")) > -1) {

      return userAgent.substring(tempVersionOffset,5);
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if ((tempVersionOffset=userAgent.indexOf("Chrome")) > -1) {
      return userAgent.substring(tempVersionOffset,8);
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    }
    else if ((tempVersionOffset=userAgent.indexOf("Chrome")) > -1) {
      return userAgent.substring(tempVersionOffset,7);
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    }
    else if ((tempVersionOffset=userAgent.indexOf("Safari")) > -1) {
      return userAgent.substring(tempVersionOffset,7);
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    }
     else {
      return "Unknown";
    }
    // trim version
    // if ((tempVersion=browserVersion.indexOf(";"))!=-1)
    //   browserVersion=browserVersion.substring(0,tempVersion);
    // if ((tempVersion=browserVersion.indexOf(" "))!=-1)
    //   browserVersion=browserVersion.substring(0,tempVersion);
    //
    // return browserVersion;
    // let tem = [];
    // let MatchPattern = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    // if (/trident/i.test(MatchPattern[1])) {
    //   tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    //   return 'IE ' + (tem[1] || '');
    // }
    // if (MatchPattern[1] === 'Chrome') {
    //   tem = userAgent.match(/\b(OPR|Edg)\/(\d+)/);
    //   if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    // }
    // MatchPattern = MatchPattern[2] ? [MatchPattern[1], MatchPattern[2]] : [navigator.appName, navigator.appVersion, '-?'];
    // if ((tem = userAgent.match(/version\/(\d+)/i)) != null) MatchPattern.splice(1, 1, tem[1]);
    // return MatchPattern.join(' ');
  },
};



// WEBPACK FOOTER //
// ./src/services/deviceInfoService.js